import { Paragraph, Button } from '@sentara-health/optimahealth_web';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library, IconName } from '@fortawesome/fontawesome-svg-core';
import { fat } from '@fortawesome/pro-thin-svg-icons';

library.add(fat);

interface CareTileProps {
  heading: string;
  subHeading?: string;
  onClick: () => void;
  dataTestId?: string;
  className?: string;
  fontAwesomeIconKey: string;
  /**
   * The optimahealth_web `icontitle_btn` button is responsive by default: the
   * icon sits beside the text on mobile (`flex-row`) and is already stacked above
   * it on desktop (`flex-md-column`). Grid tiles (Dashboard, PharmacyTools) want
   * the icon on top on mobile too, so when `stackIconOnMobile` is true (the
   * default) we add `flex-column` to force the stacked layout at every breakpoint.
   * Set it to false to keep the library's mobile row layout (e.g. VirtualVisitCare).
   */
  stackIconOnMobile?: boolean;
}

const CareTile: React.FC<CareTileProps> = ({
  heading,
  subHeading,
  onClick,
  dataTestId,
  className,
  fontAwesomeIconKey,
  stackIconOnMobile = true,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onClick();
    }
  };

  // Layout/styling is caller-controlled: pass utility classes via `className`
  // where that behavior is needed.
  return (
    <Button
      variant="icontitle_btn"
      onClick={onClick}
      onKeyDown={handleKeyDown}
      data-testid={dataTestId}
      className={['grid-col', stackIconOnMobile ? 'flex-column' : '', className]
        .filter(Boolean)
        .join(' ')}>
        <FontAwesomeIcon
          className="svg-custom-1 d-flex align-self-center"
          width={40}
          height={40}
          icon={['fat', fontAwesomeIconKey as IconName]}
        />
      {heading}
      {subHeading && (
        <Paragraph
          text={subHeading}
          variant="regular"
          className="text-center"
        />
      )}
    </Button>
  );
};

export default CareTile;